import React from 'react';
import { Image, LinkType, MandatoryVariant } from '../../types/components';
import Dialog from '../../components/Dialog/Dialog';
import ProductPreview from './ProductPreview';
import Form from '../../components/Form/Form';

export default function SidebarLink({
  siteId,
  link = undefined,
  icon,
  productTitle,
  selectedColor,
  selectedVariant,
  selectedMandatoryVariant,
  image,
}: {
  siteId: number,
  link: LinkType | undefined,
  icon: JSX.Element,
  productTitle: string,
  selectedColor: string,
  selectedVariant: number,
  selectedMandatoryVariant: MandatoryVariant | null,
  image: Image | null,
}) {
  if (link === undefined) {
    return null;
  }
  return (
    <>
      {link.type === 'form' && link.formHandle && (
        <li className="border-b border-light-grey-1 last:border-none pb-4 last:pb-0 mb-4 last:mb-0">
          <Dialog
            buttonClasses="inline-flex items-center gap-x-3 decoration-transparent hover:decoration-current underline transition-all"
            buttonContent={(
              <>
                <span className="flex justify-center items-center w-6 h-6 p-1">
                  {icon}
                </span>
                {link.linkText}
              </>
            )}
            dialogTitle={link.dialogTitle}
            dialogContent={(
              <>
                <ProductPreview
                  title={productTitle}
                  color={selectedColor}
                  image={image}
                />
                {link.dialogDescription && (
                  // eslint-disable-next-line react/no-danger
                  <div className="mb-6 sm:mb-8" dangerouslySetInnerHTML={{ __html: link.dialogDescription }} />
                )}
                <Form
                  siteId={siteId}
                  selectedVariant={selectedVariant}
                  selectedMandatoryVariant={selectedMandatoryVariant}
                  formHandle={link.formHandle}
                />
              </>
            )}
          />
        </li>
      )}
      {link.type === 'url' && (
        <li className="border-b border-light-grey-1 last:border-none pb-4 last:pb-0 mb-4 last:mb-0">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            href={link.url}
            className="inline-flex items-center gap-x-3 decoration-transparent hover:decoration-current underline transition-all"
            target={link.newWindow ? '_blank' : '_self'}
          >
            <span className="flex justify-center items-center w-6 h-6 p-1">
              {icon}
            </span>
            {link.linkText}
          </a>
        </li>
      )}
    </>
  );
}
